import useApi from '@components/Hooks/useApi';
import useGlobalState from '@components/Hooks/useGlobalState';
import useSiteConfig from '@components/Hooks/useSiteConfig';
import Fader from '@Shared/Fader';
import Icon from '@Shared/Icon';
import { IManageComplete } from '@src/interfaces';
import React, { useEffect } from 'react';
import { Badge } from 'react-bootstrap';

interface AlphaList {
  [letter: string]: Array<IManageComplete>
}


const Apps: React.FC = () => {

  const [store, dispatch] = useGlobalState();
  const api = useApi(dispatch);
  const site_config = useSiteConfig();

  useEffect(() => {
    if (site_config) {
      api.getApps(site_config.domain);
      api.getManage(site_config.domain);
    }
  }, [site_config]);

  const sortApps = (a: IManageComplete, b: IManageComplete): number => {
    return a.title < b.title
      ? -1
      : a.title > b.title
        ? 1
        : 0;
  }

  const getAppList = (): Array<IManageComplete> => {
    if (store.apps && store.manage) {
      return store.manage.concat(store.apps.map((app) => {
        return { ...app, type: 'app' };
      })).sort(sortApps);
    }
    return [];
  }

  const getAlphaList = (): AlphaList => {
    return getAppList().reduce((acc: AlphaList, app: IManageComplete) => {
      const key = app.title.substring(0, 1);
      if (!acc[key]) {
        acc[key] = []
      }
      acc[key].push(app)
      return acc
    }, {});
  }

  return getAppList().length > 4 ? (
    <div className='main-section'>
      <nav className='appl-columns' style={{ paddingTop: 19 }}>
        {Object.keys(getAlphaList()).map((letter) => {
          return (
            <div key={letter} className='app-card watermarked'>
              <Fader>
                <h4>{letter}</h4>
                <ul className='apps-list'>
                  {getAlphaList()[letter].map((app, idx) => {
                    return (
                      <li key={idx + ''}>
                        <a href={app.url}>
                          <Icon upgrade name={app.image_class.substring(3)} className='app-bullet' />
                          {app.title}
                          {!!app.badge && !!app.badge.variant && (
                            <small>
                              <Badge bg={app.badge.variant} style={{ verticalAlign: -6, marginLeft: 6 }}>
                                {app.badge.text}
                              </Badge>
                            </small>
                          )}
                        </a>
                      </li>
                    )
                  })}
                </ul>
              </Fader>
            </div>
          )
        })}
      </nav>
    </div>
  ) : (
    <div className='main-section'>
      <nav className='app-card' style={{ paddingTop: 15 }}>
        <ul className='apps-list split'>
          <Fader>
            {getAppList().map((app, idx) => {
              return (
                <li key={idx + ''}>
                  <a href={app.url}>
                    <Icon upgrade name={app.image_class.substring(3)} className='app-bullet' />
                    {app.title}
                    {!!app.badge && !!app.badge.variant && (
                      <small>
                        <Badge bg={app.badge.variant} style={{ verticalAlign: -6, marginLeft: 6 }}>
                          {app.badge.text}
                        </Badge>
                      </small>
                    )}
                  </a>
                </li>
              )
            })}
          </Fader>
        </ul>
      </nav>
    </div>
  );
}

export default Apps;